import React, { useContext, useState } from 'react'
import { Formik } from 'formik'
import withStyles from '@mui/styles/withStyles'
import { Close } from 'genesis-suite/icons'
import { Dialog, DialogContent, IconButton, Tabs, Tab, DialogTitle } from '@mui/material'

import AddUserForm from '../forms/AddUserForm'
import FormWrapper from '../forms/FormWrapper'
import { createUser, addUser, addContextUser, createContextUser } from '../../lib/yupSchemas'
import { DomainContext } from '../contexts/DomainContext'

const styles = theme => ({
    dialog: {
        minHeight: '40vh',
        maxWidth: 550,
        minWidth: 550,
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
    },
    tabs: {
        borderBottom: `1px solid ${theme.palette.grayscale.lightest}`,
    },
    tab: {
        fontWeight: theme.typography.fontWeightMedium,
    },
    formContainer: {
        flexGrow: 1,
        marginTop: theme.spacing(4),
        padding: theme.spacing(0, 2),
    },
    closeButton: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(1),
    },
    noUsers: {
        cursor: 'pointer',
    },
})

const AddUserModal = ({ open, onClose, onSubmit, classes, ...rest }) => {
    const [tab, setTab] = useState(0)
    const { requireContext } = rest

    const { companies } = useContext(DomainContext)

    const CreateUserOption = () => (
        <div className={classes.noUsers} onClick={() => setTab(1)}>
            No users found. Click to create a new user.
        </div>
    )
    return (
        <React.Fragment>
            <Dialog
                open={open}
                classes={{ paper: classes.dialog }}
                onClose={() => onClose(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle>Add User</DialogTitle>
                <DialogContent classes={{ root: classes.dialogContent }}>
                    <IconButton classes={{ root: classes.closeButton }} onClick={() => onClose(false)} size="large">
                        <Close />
                    </IconButton>
                    <Tabs
                        value={tab}
                        indicatorColor="primary"
                        classes={{ root: classes.tabs }}
                        variant="fullWidth"
                        onChange={(_, tab) => setTab(tab)}
                    >
                        <Tab value={0} label="Add Existing User(s)" classes={{ root: classes.tab }} disableRipple />
                        <Tab value={1} label="Create New User" classes={{ root: classes.tab }} disableRipple />
                    </Tabs>
                    <div className={classes.formContainer}>
                        {tab === 0 && (
                            <Formik
                                onSubmit={onSubmit}
                                validationSchema={requireContext ? addContextUser : addUser}
                                validateOnChange={false}
                                initialValues={{
                                    isExternal: false,
                                    canPublish: false,
                                    canApprove: false,
                                    permission: requireContext ? '1' : undefined,
                                }}
                                render={props => (
                                    <FormWrapper
                                        form={AddUserForm}
                                        disabledFields={[
                                            'firstName',
                                            'lastName',
                                            'email',
                                            'phone',
                                            'userId',
                                            'isExternal',
                                            'passwordExpiryInDays',
                                        ]}
                                        noUsersOption={CreateUserOption}
                                        buttonText="Add"
                                        enableSearch
                                        operation="addExistingUser"
                                        {...props}
                                        {...rest}
                                    />
                                )}
                            />
                        )}
                        {tab === 1 && (
                            <Formik
                                onSubmit={onSubmit}
                                validationSchema={requireContext ? createContextUser : createUser}
                                validateOnChange={false}
                                initialValues={{
                                    isExternal: false,
                                    canPublish: false,
                                    canApprove: false,
                                    permission: requireContext ? '1' : undefined,
                                }}
                                render={props => (
                                    <FormWrapper form={AddUserForm} operation="createUser" {...rest} {...props} />
                                )}
                            />
                        )}
                    </div>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}

export default withStyles(styles)(AddUserModal)
